import { FormattedMessage } from "@/i18n/i18n-client";
import { Spinner } from "@/shared/globals";
import Button from "@/templates/modern/components/Button/Button";
import { ModalStep } from "./ModalHeader";
import { LoginMethod } from "@/templates/types/LoginFormProps";

interface ActionButtonsProps {
  step: ModalStep;
  method: LoginMethod;
  isLoading: boolean;
  otp: string;
  signupName: string;
  signupEmail: string;
  watchValue: (field: string) => any;
  onBackToLogin: () => void;
  onVerifyOTP: () => void;
  onSignup: () => void;
  errors?: any;
  countdown?: number;
  isCountdownActive?: boolean;
}

const ActionButtons = ({
  step,
  method,
  isLoading,
  otp,
  signupName,
  signupEmail,
  watchValue,
  onBackToLogin,
  onVerifyOTP,
  onSignup,
  errors,
  countdown = 0,
  isCountdownActive = false,
}: ActionButtonsProps) => {
  if (step === ModalStep.login) {
    const isCountdownActive_local = isCountdownActive && countdown > 0;

    return (
      <div className="flex flex-row w-full">
        <Button
          isDisabled={isLoading || isCountdownActive_local}
          htmlType="submit"
          fullWidth
        >
          {isLoading ? (
            <div className="flex flex-row items-center justify-center">
              <Spinner />
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center gap-2">
              <FormattedMessage defaultMessage="Log in" id="odXlk8" />
              {isCountdownActive_local && (
                <span className="text-sm">({countdown}s)</span>
              )}
            </div>
          )}
        </Button>
      </div>
    );
  }

  if (step === ModalStep.signup) {
    return (
      <div className="flex flex-row w-full gap-4 pt-2">
        <Button
          className="flex-1"
          onClick={onSignup}
          isDisabled={
            isLoading ||
            !signupName ||
            (method === LoginMethod.EMAIL &&
              !watchValue("signupPhoneNumber")) ||
            (method === LoginMethod.PHONE && !signupEmail) ||
            errors?.signupName || // Disable if there's a name validation error
            (method === LoginMethod.EMAIL && errors?.signupPhoneNumber) ||
            (method === LoginMethod.PHONE && errors?.signupEmail)
          }
          htmlType="button"
          fullWidth
        >
          {isLoading ? (
            <div className="flex flex-row items-center justify-center">
              <Spinner />
            </div>
          ) : (
            <FormattedMessage defaultMessage="Create account" id="huqKGl" />
          )}
        </Button>
      </div>
    );
  }

  // OTP verification buttons
  return (
    <div className="flex flex-row w-full gap-4 pt-2">
      <Button
        className="flex-1"
        onClick={() => {
          onBackToLogin();
        }}
        htmlType="button"
        type="secondary"
        fullWidth
      >
        <FormattedMessage defaultMessage="Back" id="cyR7Kh" />
      </Button>
      <Button
        className="flex-1"
        onClick={onVerifyOTP}
        isDisabled={isLoading || !otp || otp.length < 4}
        htmlType="button"
        fullWidth
      >
        {isLoading ? (
          <div className="flex flex-row items-center justify-center">
            <Spinner />
          </div>
        ) : (
          <FormattedMessage defaultMessage="Verify" id="q5Xl0M" />
        )}
      </Button>
    </div>
  );
};

export default ActionButtons;
